import { render, staticRenderFns } from "./PageFootModule.vue?vue&type=template&id=ef371d66&scoped=true"
import script from "./PageFootModule.vue?vue&type=script&lang=js"
export * from "./PageFootModule.vue?vue&type=script&lang=js"
import style0 from "./PageFootModule.vue?vue&type=style&index=0&id=ef371d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef371d66",
  null
  
)

export default component.exports